function Badge({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold-strong ${className}`.trim()}
    >
      <span className="h-px w-8 bg-brand-gold-strong/70" />
      {children}
    </span>
  );
}

export default Badge;
